export default __webpack_public_path__ + "static/media/tusd.4b67e5aa.svg";